// src/templates/empanadaclub/components/routes/ProtectedFranquiciadoRoute.jsx
// Ruta protegida personalizada de franquiciado para Empanada Club
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useAuthStore from '../../../../store/authStore';

const ProtectedFranquiciadoRoute = () => {
    const { franquiciado, isAuthenticated } = useAuthStore(state => ({
        franquiciado: state.franquiciado,
        isAuthenticated: state.isAuthenticated
    }));

    if (!isAuthenticated || !franquiciado) {
        return <Navigate to="/franquiciado/login" replace />;
    }

    return <Outlet />;
};

export default ProtectedFranquiciadoRoute;

